import { render, staticRenderFns } from "./joinManagement.vue?vue&type=template&id=28679198&"
import script from "./joinManagement.vue?vue&type=script&lang=js&"
export * from "./joinManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports